import { render, staticRenderFns } from "./QuickEvent.vue?vue&type=template&id=795b673c"
import script from "./QuickEvent.vue?vue&type=script&lang=js"
export * from "./QuickEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports